// extracted by mini-css-extract-plugin
module.exports = {"myTable":"style_myTable__1_w_o"};